module.exports = __webpack_public_path__ + "static/wpais-e43022766984bf01b7ec139a6f582476.png";